import $ from "jquery";

import { HandySvg } from "handy-svg";
import iconRightArrow from "../../assets/icons/svg-sprite/arrow-right.svg";
import iconLeftArrow from "../../assets/icons/svg-sprite/arrow-left.svg";
import iconShowMore from "../../assets/icons/svg-sprite/show-more.svg";
import iconPrint from "../../assets/icons/svg-sprite/print.svg";

import { useState, useEffect, useCallback } from "react";
import LazyTooltip from "../../components/lazyTooltip/LazyTooltip";
import dateCalculation from "../../modules/date-calculation";
import toggleSocialsInTVPopover from "../../modules/tv-program-toggle-socials";
import modalProgram from "../../modules/modal-program";
import CategoryButton from "../../components/categoryButton/CategoryButton";
import ChannelHeader from "../../components/channelHeader/ChannelHeader";
import Print from "../print/print";
import { tv, favorites } from "../../lib/api/api";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const TVProgram = () => {
  const [schemes, setSchemes] = useState([]);
  const [programCategories, setProgramCategories] = useState([]);
  const [tariffs, setTariffs] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [favoritesTV, setFavoritesTV] = useState([]);
  const [data, setData] = useState({
    limit: 6,
    offset: 0,
    date: "now",
    total: 8,
  });

  useEffect(() => {
    toggleSocialsInTVPopover();
    modalProgram();
    tvProgram();
    tv.tvCategories()
      .then((res) => {
        const activeCategories = res.categories.filter(
          (item) => item.weight > 0,
        );
        setProgramCategories(activeCategories);
        const sheet = document.createElement("style");
        activeCategories.forEach((item) => {
          sheet.innerHTML += `.tv-program__program--selected-${item.id} {background-color: ${item.attributes["background-color"]}32;}`;
        });
        document.body.appendChild(sheet);
      })
      .catch((err) => {
        console.log(err);
      });
    tv.tariffs()
      .then((res) => {
        setTariffs(res.tariffs);
      })
      .catch((err) => {
        console.log(err);
      });
    favorites
      .favorites()
      .then((res) => {
        setFavoritesTV(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    channelList(data.limit, data.offset, data.date, data.total);
  }, [data]);

  function channelList(limit, offset, date, total) {
    tv.tvs(limit, offset, date, total)
      .then((res) => {
        setSchemes(res.schemes);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function categoryDistribution(id) {
    setSelectedCategories((prevState) => {
      const index = prevState.indexOf(id);
      return index !== -1
        ? prevState.filter((item) => item !== id)
        : [...prevState, id];
    });
  }

  function tvProgram() {
    $("#tv-program-date-select").selectize({
      options: [
        { value: dateCalculation(-7)[0], name: dateCalculation(-7)[1] },
        { value: dateCalculation(-6)[0], name: dateCalculation(-6)[1] },
        { value: dateCalculation(-5)[0], name: dateCalculation(-5)[1] },
        { value: dateCalculation(-4)[0], name: dateCalculation(-4)[1] },
        { value: dateCalculation(-3)[0], name: dateCalculation(-3)[1] },
        { value: dateCalculation(-2)[0], name: dateCalculation(-2)[1] },
        { value: dateCalculation(-1)[0], name: "Вчера" },
        { value: "now", name: "Сейчас" },
        { value: dateCalculation(0)[0], name: "Сегодня" },
        { value: dateCalculation(1)[0], name: "Завтра" },
        { value: dateCalculation(2)[0], name: dateCalculation(2)[1] },
        { value: dateCalculation(3)[0], name: dateCalculation(3)[1] },
        { value: dateCalculation(4)[0], name: dateCalculation(4)[1] },
        { value: dateCalculation(5)[0], name: dateCalculation(5)[1] },
        { value: dateCalculation(6)[0], name: dateCalculation(6)[1] },
        { value: dateCalculation(7)[0], name: dateCalculation(7)[1] },
        { value: dateCalculation(8)[0], name: dateCalculation(8)[1] },
        { value: dateCalculation(9)[0], name: dateCalculation(9)[1] },
      ],
      render: {
        option(item, escape) {
          return `
                        <div class="option" data-value="${escape(
                          item.value,
                        )}">${escape(item.name)}</div>
                    `;
        },
        item(item, escape) {
          return `
                        <div class="item" data-value="${escape(
                          item.value,
                        )}">${escape(item.name)}</div>
                    `;
        },
      },
    });
    const selectizeControl = $("#tv-program-date-select")[0].selectize;
    selectizeControl.setValue("now");
    selectizeControl.on("change", function () {
      changeDateSelect(selectizeControl.getValue());
    });
    $("#tv-program-date-select").attr("readonly", "readonly");
  }

  const loadMoreData = useCallback(
    () =>
      setData((prevState) => ({
        ...prevState,
        limit: prevState.limit + 6,
      })),
    [],
  );

  const changeOfDate = useCallback((event) => {
    setData((prevState) => ({
      ...prevState,
      date: event.target.dataset.value,
    }));
    const dateLinks = document.querySelectorAll(
      ".tv-program__date-slider-link",
    );
    dateLinks.forEach((item) => item.classList.remove("is-active"));
    event.target.classList.add("is-active");
    $("#tv-program-date-select")[0].selectize.setValue(
      event.target.dataset.value,
    );
  }, []);

  const changeDateSelect = useCallback((selectedDate) => {
    setData((prevState) => ({
      ...prevState,
      date: selectedDate,
    }));
    const dateLinks = document.querySelectorAll(
      ".tv-program__date-slider-link",
    );
    dateLinks.forEach((item) => item.classList.remove("is-active"));
    dateLinks.forEach((item) => {
      if (item.dataset.value === selectedDate) {
        item.classList.add("is-active");
      }
    });
  }, []);

  return (
    <>
      <div className="tv-program page__tv-program" id="tv-program">
        <div className="tv-program__header">
          <div className="tv-program__header-inner page-container">
            <h2 className="tv-program__title title title--h2">
              Программа передач
            </h2>
            <div className="tv-program__date-wrapper">
              <div className="tv-program__date-select">
                <div className="select js-select">
                  <select
                    className="select__item"
                    id="tv-program-date-select"
                  />
                </div>
              </div>
              <div className="tv-program__date-slider">
                <button
                  className="tv-program__date-slider-btn tv-program__date-slider-btn--prev js-tv-program-date-slider-prev-btn bttn"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconLeftArrow}
                    width="16"
                    height="16"
                  />
                </button>
                <Swiper
                  slidesPerView={"auto"}
                  modules={[Navigation]}
                  initialSlide={6}
                  className="tv-program__date-slider-slick"
                  navigation={{
                    prevEl: ".js-tv-program-date-slider-prev-btn",
                    nextEl: ".js-tv-program-date-slider-next-btn",
                  }}
                >
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-7)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-7)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-6)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-6)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-5)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-5)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-4)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-4)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-3)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-3)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-2)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(-2)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(-1)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      Вчера
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link is-active"
                      data-value="now"
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      Сейчас
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(0)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      Сегодня
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(1)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      Завтра
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(2)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(2)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(3)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(3)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(4)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(4)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(5)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(5)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(6)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(6)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(7)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(7)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(8)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(8)[1]}
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="tv-program__date-slider-slide">
                    <a
                      className="tv-program__date-slider-link"
                      data-value={dateCalculation(9)[0]}
                      href="javascript:void(0)"
                      onClick={changeOfDate}
                    >
                      {dateCalculation(9)[1]}
                    </a>
                  </SwiperSlide>
                </Swiper>
                <button
                  className="tv-program__date-slider-btn tv-program__date-slider-btn--next js-tv-program-date-slider-next-btn bttn"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconRightArrow}
                    width="16"
                    height="16"
                  />
                </button>
              </div>
            </div>
            <div className="tv-program__tags">
              <ul className="tv-program__tags-inner">
                {programCategories.map((category) => (
                  <CategoryButton
                    category={category}
                    categoryDistribution={categoryDistribution}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="tv-program__body">
          <div className="tv-program__body-inner page-container">
            <div className="tv-program__channels-list">
              {schemes.map((channel) => (
                <div className="tv-program__channel page__area">
                  <ChannelHeader
                    id={channel.channel_id}
                    favoritesTV={favoritesTV}
                    tariffs={tariffs}
                  />
                  <div className="tv-program__channel-body">
                    <ul className="tv-program__channel-schedule">
                      {channel.programs.map((program) => (
                        <LazyTooltip
                          key={program.scheme.id}
                          program={program}
                          selectedCategories={selectedCategories}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
            <div className="tv-program__actions">
              <button
                className="tv-program__action-btn tv-program__show-more ghost-btn ghost-btn--blue bttn"
                onClick={loadMoreData}
              >
                <HandySvg
                  className="svg-icon tv-program__action-icon"
                  src={iconShowMore}
                  width="24"
                  height="24"
                />
                Показать еще
              </button>
              <a
                className="tv-program__action-btn tv-program__print ghost-btn ghost-btn--gray bttn btn-modal-program"
                href="javascript:void(0)"
                data-modal="#modal-print"
              >
                <HandySvg
                  className="svg-icon tv-program__action-icon"
                  src={iconPrint}
                  width="24"
                  height="24"
                />
                Распечатать
              </a>
            </div>
          </div>
        </div>
        <Print />
      </div>
    </>
  );
};

export default TVProgram;
